import { ContainedModal } from 'components/molecules';
import { PetTreatmentInformations } from 'components/molecules/pet/PetTreatmentInformations';
import { useTreatmentOnGoing } from 'context';

import React from 'react';

export const PetInformationsModal: React.FC = () => {
  const { treatmentOnGoing, petInformationsModal } = useTreatmentOnGoing();

  if (!treatmentOnGoing?.id) {
    return null;
  }

  const { pet, tutor } = treatmentOnGoing;

  return (
    <ContainedModal
      isOpen={petInformationsModal.isOpen}
      onClose={petInformationsModal.onClose}
      title="DADOS DO PET"
    >
      <PetTreatmentInformations
        pet={pet}
        tutorName={tutor?.name}
        paddingLeft={3}
        my={4}
        planName={tutor?.company ? tutor?.company.companyName : 'Vet4One'}
      />
    </ContainedModal>
  );
};